import { render } from "./DashboardNavBar.vue?vue&type=template&id=8740dc18&scoped=true"
import script from "./DashboardNavBar.vue?vue&type=script&lang=js"
export * from "./DashboardNavBar.vue?vue&type=script&lang=js"

import "./DashboardNavBar.vue?vue&type=style&index=0&id=8740dc18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8740dc18"]])

export default __exports__